import styled from 'styled-components';

const dividerStyles = (color: string): string => `
  border-top: 1px solid ${color};
  padding-top: 24px;
`;

export const Box = styled.div<{ isPublished: boolean; isInitialNote: boolean }>`
  margin-bottom: 24px;
  ${(prop) =>
    !prop.isPublished && !prop.isInitialNote && dividerStyles(prop.theme.colors['neutral-30'])}
`;

export const NoteInfos = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const AuthorName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
  margin-right: 8px;
`;

export const NoteTime = styled.span`
  font-size: 10px;
  line-height: 140%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
`;

export const ButtonsBox = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 16px;
`;
